import Axios from "axios";
import { GetUserReportsResponse } from "../models/userReport.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, UserReport } from "../config/config";

export const GetUserReports = async (data: {
  userId: number;
}): Promise<GetUserReportsResponse[]> => {
  return await Axios.post<ApiResultModel<GetUserReportsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + UserReport + "/GetUserReports",
    data
  ).then((result) => {
    return result.data.data;
  });
};
